import React from 'react';
import { Card, createStyles, makeStyles, Typography } from '@bb-ui/react-library';
import type { SummaryWidget as SummaryWidgetType } from '@lct-jobs/config';
import { ExecutionDetailResponseBody } from '@lct-jobs/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      borderRadius: 12,
      border: '1px solid rgba(0, 0, 0, 0.08)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
      padding: theme.spacing(3),
    },
    title: {
      marginBottom: theme.spacing(1),
      fontWeight: 600,
    },
    subtitle: {
      marginBottom: theme.spacing(0.5),
      color: theme.palette.text.secondary,
    },
    tenant: {
      color: theme.palette.text.secondary,
    },
  }),
);

export interface JobSummaryProps {
  jobExecution?: ExecutionDetailResponseBody;
}

export const SummaryWidget: React.FC<JobSummaryProps> = (props) => {
  const execution = props.jobExecution;
  const classes = useStyles();
  const widget = execution?.jobConfig?.jobSummary as SummaryWidgetType | undefined;
  if (widget && widget.widgetId && widget.inputPaths) {
    switch (widget.widgetId) {
      case 'TitleSubtitleTenant':
        return (
          <Card className={classes.card}>
            <Typography variant="h4" className={classes.title}>
              {widget.inputPaths.title ?? ''}
            </Typography>
            <Typography className={classes.subtitle}>{widget.inputPaths.subtitle}</Typography>
            <Typography className={classes.tenant}>{widget.inputPaths.tenant}</Typography>
          </Card>
        );
      case 'TitleTenant':
        return (
          <Card className={classes.card}>
            <Typography variant="h4" className={classes.title}>
              {widget.inputPaths.title}
            </Typography>
            <Typography className={classes.tenant}>{widget.inputPaths.tenant}</Typography>
          </Card>
        );
      case 'TitleSubtitleLink':
        return (
          <Card className={classes.card}>
            <Typography variant="h4" className={classes.title}>
              {widget.inputPaths.title}
            </Typography>
            <Typography className={classes.subtitle}>{widget.inputPaths.subtitle}</Typography>
            <Typography>
              <a href={widget.inputPaths.link}>Link</a>
            </Typography>
          </Card>
        );
      default:
        return null;
    }
  } else {
    return null;
  }
};
